/* src/app/invoice/setup/invoice-setup-presenter/invoice-setup-presenter.component.scss */
#spnTaxpayerId,
#spnShowindirectrates,
#spnFeeseparate,
#spnShowlaborrates {
  min-width: 5em;
}
#spnShowCN {
  min-width: 8em;
}
/*# sourceMappingURL=invoice-setup-presenter.component.css.map */
